import React from "react";

/**
 * Valor Total da apólice. Valores da carga antiga foram gravados como prêmio
 * líquido (sem IOF) — premiumSource "liquido" — e ganham um asterisco com a
 * explicação, até serem atualizados pelo valor total.
 */
const PremiumValue = ({ value, source, format }) => (
  <>
    {format(value)}
    {source === "liquido" ? (
      <span title="valor sem IOF" aria-label="valor sem IOF" style={{ cursor: "help" }}>
        *
      </span>
    ) : null}
  </>
);

export default PremiumValue;
